/* Anirveda inner pages (Foxtale clone): article "In this article" list from the H2s, "view more" text, copy-link share. */
(function () {
  function buildToc(root) {
    root.querySelectorAll('[data-fxp-toc]').forEach(function (toc) {
      if (toc.dataset.ready) return;
      toc.dataset.ready = '1';
      var body = document.querySelector(toc.dataset.fxpToc);
      if (!body) return;
      var heads = body.querySelectorAll('h2');
      if (heads.length < 2) { toc.hidden = true; return; }
      var list = toc.querySelector('ol');
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var more = t.closest('[data-fxp-more]');
    if (more) {
      var box = more.closest('.ani-fxp-seo');
      var open = box.dataset.open !== 'true';
      box.dataset.open = String(open);
      more.textContent = open ? more.dataset.less : more.dataset.more;
      more.setAttribute('aria-expanded', String(open));
      return;
    }
    var copy = t.closest('[data-fxp-copy]');
    if (copy) {
      e.preventDefault();
      if (navigator.share) { navigator.share({ title: document.title, url: copy.dataset.fxpCopy }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(copy.dataset.fxpCopy); copy.setAttribute('aria-label', 'Link copied'); }
    }
  });

  buildToc(document);
  document.addEventListener('shopify:section:load', function (e) { buildToc(e.target); });
})();
